import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ICON_SPRITE } from './icon-sprite';

const SPRITE_HOST_ID = 'c-icon-sprite';

/** Injects the inlined sprite once, so `<use href="#name">` resolves in-document (no request to /assets). */
function ensureSprite(): void {
  if (document.getElementById(SPRITE_HOST_ID)) {
    return;
  }
  const host = document.createElement('div');
  host.id = SPRITE_HOST_ID;
  host.style.display = 'none';
  host.innerHTML = ICON_SPRITE;
  document.body.appendChild(host);
}

@Component({
  selector: 'c-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  /** icon name */
  @Input() icon: string;

  constructor() {
    ensureSprite();
  }

}
